import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmationModalComponent } from "../../common/confirmation-modal/confirmation-modal.component";
import { saveUserDataInSession } from "src/app/utils/session-data";
import { RegisterComponent } from "../register/register.component";

@Component({
  selector: "app-otp",
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.scss"],
})
export class OtpComponent {
  otp: string | null = null;
  response: any;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      width: "30px",
      height: "30px",
    },
  };
  onOtpChange(otp: string) {
    this.otp = otp;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ref: MatDialogRef<OtpComponent>,
    private auth: AuthService,
    private dialog: MatDialog
  ) {}

  onSubmit() {
    // console.log(this.otp);
    if (this.otp?.length == 4) {
      // console.log(this.otp);
      const body = {
        mobile: this.data.number,
        access_type: "web",
        otp: this.otp,
        otp_ref: this.data.ref,
      };

      this.auth.otpVerify(body).subscribe(
        (res: any) => {
          if (res.error === false) {
            if (res.details.first_name != "" && res.details.last_name != "") {
              saveUserDataInSession(res.details);
              this.closeDialog("done");
            } else {
              this.response = res.details;
              this.openRegister(
                res.details.credentials.access_token,
                res.details.email,
                res.details.first_name,
                res.details.last_name
              );
            }
          } else {
            // console.log("Login failed: ", res.error_message);
          }
        },
        (error) => {
          console.error("Error:", error);
          this.openDialog(error.error.message);
        }
      );
    } else {
      // console.log(this.otp);
      // Form is not valid, handle validation errors if needed
    }
  }

  openRegister(
    mToken: string,
    email: string,
    first_name: string,
    last_name: string
  ) {
    const dialogRef = this.dialog.open(RegisterComponent, {
      enterAnimationDuration: "200ms",
      data: {
        token: mToken,
        email: email,
        first_name: first_name,
        last_name: last_name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "done") {
        saveUserDataInSession(this.response);
      }
      this.closeDialog("done");
    });
  }

  closeDialog(msg: string) {
    this.ref.close(msg);
  }

  openDialog(err: String) {
    this.dialog.open(ConfirmationModalComponent, {
      enterAnimationDuration: "350ms",
      data: {
        error: err,
      },
    });
  }
}
